// Detectar ambiente baseado no hostname
const isProduction = window.location.hostname === 'app.salustrack.com' || 
                   window.location.hostname.includes('amplifyapp.com');
const isLocal = window.location.hostname === 'localhost';

// Use runtime config if available (from public/config.js)
const runtimeConfig = window.APP_CONFIG || {};



const environmentConfig = {
  API_URL: runtimeConfig.API_URL || 
           (isProduction 
             ? 'https://api.salustrack.com/api/v1'
             : (process.env.REACT_APP_API_URL || 'https://brdko0pg9l.execute-api.us-west-2.amazonaws.com/prod/api/v1')),
  WS_URL: runtimeConfig.WS_URL ||
          (isProduction 
            ? 'wss://xivmrev4qa.execute-api.us-west-2.amazonaws.com/prod'
            : (process.env.REACT_APP_WS_URL || 'wss://xivmrev4qa.execute-api.us-west-2.amazonaws.com/prod')),
  COGNITO_USER_POOL_ID: runtimeConfig.COGNITO_USER_POOL_ID || process.env.REACT_APP_COGNITO_USER_POOL_ID_PROD || 'us-west-2_6NaygtqLh',
  COGNITO_CLIENT_ID: runtimeConfig.COGNITO_CLIENT_ID || process.env.REACT_APP_COGNITO_CLIENT_ID_PROD || '240r8kacjngq3bgdlpq9veabs8',
  AWS_REGION: runtimeConfig.AWS_REGION || process.env.REACT_APP_AWS_REGION || 'us-west-2',
  IS_PRODUCTION: isProduction,
  IS_LOCAL: isLocal
};



export default environmentConfig;